module.exports = {
  pathPrefix: '/', // Prefix for all links. If you deploy your site to example.com/portfolio your pathPrefix should be "portfolio"

  siteTitle: 'Galin Yanev', // Navigation and Site Title
  siteTitleAlt: 'Galin Yanev Art', // Alternative Site title for SEO
  siteTitleShort: 'Galin Yanev', // short_name for manifest
  siteHeadline: 'Galin Yanev Abstract Art', // Headline for schema.org JSONLD
  siteUrl: 'https://galinyanev.com', // Domain of your site. No trailing slash!
  siteLanguage: 'en', // Language Tag on <html> element
  siteLogo: '/logos/logo.png', // Used for SEO and manifest
  siteDescription: 'Galin Yanev Abstract Art',
  author: 'Galin Yanev', // Author for schema.org JSONLD

  // userTwitter: '@jumpalottahigh', // Twitter Username
  ogSiteName: 'galinyanev', // Facebook Site Name
  ogLanguage: 'en_US', // og:language
  googleAnalyticsID: 'UA-43588334-7',

  // Manifest and Progress color
  themeColor: '#3498DB',
  backgroundColor: '#2b2e3c',

  // Your information
  avatar: '/logos/logo.png',
  name: 'Galin Yanev',
  location: 'Cyprus',
  socialMedia: [
    {
      url: 'https://www.deviantart.com/artsygalin',
      name: 'Deviant Art',
    },
  ],
}
